// Обёртка экрана: шапка 56px плюс тело фиксированной высоты (M1.1, M1.3).
//
// Смысл в том, чтобы геометрия была ровно одна на все экраны: шапка не «дышит»
// при переходе, тело всегда ровно остаток высоты, страница целиком не ездит.
// Прокрутку внутри тела экран объявляет сам (класс .ab-mscroll): почти каждому
// нужна панель, приклеенная к низу — диктовка в заметке, строка ввода в беседе,
// FAB в базе, — а над ней независимо прокручиваемый список.

import type { ReactNode } from 'react'
import { useAppStore } from '../store/appStore'

interface Props {
  title: string
  /** Путь или статус под заголовком — моноширинным 12px. */
  sub?: string
  /** Кнопка «назад». Без неё шапка корневая: стрелки нет, заголовок у 16px. */
  onBack?: () => void
  /** Кнопки шапки экрана — встают слева от переключателя темы. */
  actions?: ReactNode
  children?: ReactNode
}

export default function Screen({ title, sub, onBack, actions, children }: Props) {
  const theme = useAppStore((s) => s.theme)
  const toggleTheme = useAppStore((s) => s.toggleTheme)
  const dark = theme === 'dark'

  return (
    <div className="ab-mscreen">
      <header className={`ab-mhead${onBack ? ' ab-mhead--back' : ''}`}>
        {onBack ? (
          <button className="ab-mbtn ab-mbtn--back" onClick={onBack} aria-label="назад" title="назад">
            ‹
          </button>
        ) : null}
        <div className="ab-mhead__title">
          <span className="ab-mhead__name">{title}</span>
          {sub ? <span className="ab-mhead__sub">{sub}</span> : null}
        </div>
        {actions}
        <button
          className="ab-mbtn"
          onClick={toggleTheme}
          aria-label={dark ? 'светлая тема' : 'тёмная тема'}
          title={dark ? 'светлая тема' : 'тёмная тема'}
        >
          {dark ? '☀' : '☾'}
        </button>
      </header>
      {/* Прокрутку объявляет сам экран (.ab-mscroll): почти всем нужна
          закреплённая внизу панель, под которой список ездит отдельно. */}
      <div className="ab-mscreen__body">{children}</div>
    </div>
  )
}
